import { LoaderExcludes } from 'src/app/_Core/_Constants/api.constant';
import { NavigationEnd, Router } from '@angular/router';
import { LoaderComponent } from 'src/app/_Shared/_Components/_Generic/loader/loader.component';
import { ToastMessage } from 'src/app/_Shared/_Components/_Generic/toast/toast.component';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { NotificationService } from 'src/app/_Core/_Services/notification.service';
import { AppConstant } from 'src/app/_Core/_Constants/app.constant';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'capitaland';
  url: string;
  accessToken: any;
  token_type: any;
  isLoggedIn: boolean = false;
  public LoaderComponent = LoaderComponent;
  public LoaderExcludes = LoaderExcludes;
  @ViewChild(ToastMessage) toastRef: ToastMessage;
  constructor(
    private appStateSrv: AppStateProvider,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private notificationSrv: NotificationService
  ) {
    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd) {
        //Registering notifications fetch method
        if (localStorage.getItem(AppConstant.localStorage.userId) !== null && localStorage.getItem(AppConstant.localStorage.userId) !== undefined)
          this.notificationSrv.getAllNotifications().subscribe();
      }
    });
  }
  ngOnInit() {
    this.appStateSrv.getLoginStatus().subscribe((status: boolean) => {
      console.log('login status ', status);
      this.isLoggedIn = status;
      this.cdr.detectChanges();
    });

    this.appStateSrv.toastMessage.subscribe(message => {
      console.log('message');

      if (message)
        this.toastRef.showToastMessage(message);
    })

  }

  excludeUrl() {
    let check = ['vmsGuest', 'userConsent'].some(substring => this.router.url.includes(substring))
    return ((check) ? false : true)
  }

}

